import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/shared/components/ui/accordion";
import { Input } from "@/shared/components/ui/input";
import { PasswordInput } from "@/shared/components/ui/password-input";
import { Label } from "@/shared/components/ui/label";
import { useTranslation } from "react-i18next";

interface ConfigTeamsState {
  azureAdTenantId: string;
  azureAdClientId: string;
  azureAdClientSecret: string;
  botUserId: string;
  botName: string;
  botBaseUrl: string;
  certThumbprint: string;
}

interface ConfigTeamsSectionProps {
  config: ConfigTeamsState;
  onChange: (field: string, value: string | boolean) => void;
}

export const ConfigTeamsSection = ({ config, onChange }: ConfigTeamsSectionProps) => {
  const { t } = useTranslation();

  return (
    <>
      <p className="text-xs font-semibold text-primary uppercase tracking-wider mt-6 mb-3">
        {t("assistant.config.microsoftTeams")}
      </p>

      <Accordion type="multiple" className="w-full">
        <AccordionItem value="azureAd">
          <AccordionTrigger className="text-sm font-medium uppercase tracking-wide">
            {t("assistant.config.azureAd")}
          </AccordionTrigger>
          <AccordionContent>
            <div className="space-y-3">
              <div className="space-y-1.5">
                <Label className="text-xs text-muted-foreground">{t("assistant.config.azureAdTenantId")}</Label>
                <Input value={config.azureAdTenantId} onChange={(e) => onChange("azureAdTenantId", e.target.value)} placeholder="00000000-0000-0000-0000-000000000000" className="text-sm" />
              </div>
              <div className="space-y-1.5">
                <Label className="text-xs text-muted-foreground">{t("assistant.config.azureAdClientId")}</Label>
                <Input value={config.azureAdClientId} onChange={(e) => onChange("azureAdClientId", e.target.value)} placeholder="00000000-0000-0000-0000-000000000000" className="text-sm" />
              </div>
              <div className="space-y-1.5">
                <Label className="text-xs text-muted-foreground">{t("assistant.config.azureAdClientSecret")}</Label>
                <PasswordInput value={config.azureAdClientSecret} onChange={(e) => onChange("azureAdClientSecret", e.target.value)} placeholder="••••••••" className="text-sm" />
              </div>
            </div>
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="azureBot">
          <AccordionTrigger className="text-sm font-medium uppercase tracking-wide">
            {t("assistant.config.azureBot")}
          </AccordionTrigger>
          <AccordionContent>
            <div className="space-y-3">
              <div className="space-y-1.5">
                <Label className="text-xs text-muted-foreground">{t("assistant.config.botUserId")}</Label>
                <Input value={config.botUserId} onChange={(e) => onChange("botUserId", e.target.value)} placeholder="00000000-0000-0000-0000-000000000000" className="text-sm" />
              </div>
              <div className="space-y-1.5">
                <Label className="text-xs text-muted-foreground">{t("assistant.config.botName")}</Label>
                <Input value={config.botName} onChange={(e) => onChange("botName", e.target.value)} className="text-sm" />
              </div>
              <div className="space-y-1.5">
                <Label className="text-xs text-muted-foreground">{t("assistant.config.botBaseUrl")}</Label>
                <Input value={config.botBaseUrl} onChange={(e) => onChange("botBaseUrl", e.target.value)} className="text-sm" />
              </div>
              <div className="space-y-1.5">
                <Label className="text-xs text-muted-foreground">{t("assistant.config.certThumbprint")}</Label>
                <PasswordInput value={config.certThumbprint} onChange={(e) => onChange("certThumbprint", e.target.value)} placeholder="••••••••" className="text-sm" />
              </div>
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </>
  );
};
